<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Estrategias de Cobranza</h1>
      <p class="mb-3 text-color-secondary">
        Configura estrategias automatizadas de comunicación multi-canal. Define cuándo, 
        cómo y a quién enviar recordatorios de pago según escenarios temporales 
        (antes/durante/después del vencimiento).
      </p>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError" class="error-container">
    <div class="error-content">
      <i class="fa-solid fa-exclamation-triangle error-icon"></i>
      <h3>Oops! Algo salió mal</h3>
      <p>{{ errorMessage }}</p>
      <button pButton label="Reintentar" icon="pi pi-refresh" (click)="retry()"></button>
    </div>
  </div>

  <!-- Content -->
  <app-main-table *ngIf="!hasError"
    [columns]="columns"
    [actions]="actions"
    [apiService]="apiStrategiesService"
    [additionalMainActions]="additionalMainActions"
    (onAction)="handleTableAction($event)"
    (onMainAction)="mainActions($event)"
  ></app-main-table>
</p-card>

<!-- Dialog para Wizard de Estrategia -->
<p-dialog
  [(visible)]="createEntity"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [header]="action === 'CREATE' ? 'Nueva Estrategia de Cobranza' : 'Editar Estrategia'"
  (onHide)="hideDialog()"
>
  <app-strategy-wizard
    *ngIf="createEntity"
    (onSave)="saveForm()"
    (onCancel)="hideDialog()"
  ></app-strategy-wizard>
</p-dialog>

<!-- Toast para mensajes -->
<p-toast></p-toast>

<!-- Dialog de confirmación -->
<p-confirmDialog></p-confirmDialog>
